module.exports = __webpack_public_path__ + "images/emoji/blush.862eaf1dadd7e64a25c7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/blush.png
// module id = xJhN
// module chunks = 13